import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  FaFacebook,
  FaWhatsapp,
  FaInstagram,
  FaPinterest,
  FaTwitter,
} from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import useLogoUrl from "../../../hooks/useLogoURL";
import useSetupDetails from "../../../hooks/useSetupDetails";

export default function Invoice() {
  const { user } = useSelector((state) => state.AuthReducer);
  const { specificPurchase } = useSelector((state) => state.PurchaseReducer);
  const { categories, subCategories } = useSelector(
    (state) => state.CategoryReducer
  );
  const { allVarients, products } = useSelector(
    (state) => state.ProductReducer
  );

  const [currentTime, setCurrentTime] = useState("");
  const logoUrl = useLogoUrl();
  const { setupDetails } = useSetupDetails();
  useEffect(() => {
    if (specificPurchase) {
      // Function to update the current time
      const updateTime = () => {
        const date = new Date(specificPurchase?.created_at);
        const timeString = date.toLocaleTimeString([], {
          hour: "numeric",
          minute: "2-digit",
        });
        setCurrentTime(timeString);
      };

      // Update the time initially
      updateTime();

      // Update the time every second
      const interval = setInterval(updateTime, 1000);

      // Clean up the interval on component unmount
      return () => clearInterval(interval);
    } else {
      // Function to update the current time
      const updateTime = () => {
        const date = new Date();
        const timeString = date.toLocaleTimeString([], {
          hour: "numeric",
          minute: "2-digit",
        });
        setCurrentTime(timeString);
      };

      // Update the time initially
      updateTime();

      // Update the time every second
      const interval = setInterval(updateTime, 1000);

      // Clean up the interval on component unmount
      return () => clearInterval(interval);
    }
  }, [specificPurchase]);

  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    if (specificPurchase) {
      // Function to update the current date
      const updateDate = () => {
        const date = new Date(specificPurchase?.created_at);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const dateString = `${day}/${month}/${year}`;
        setCurrentDate(dateString);
      };

      // Update the date initially
      updateDate();

      // Clean up on component unmount
      return () => {};
    } else {
      // Function to update the current date
      const updateDate = () => {
        const date = new Date();
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const dateString = `${day}/${month}/${year}`;
        setCurrentDate(dateString);
      };

      // Update the date initially
      updateDate();

      // Clean up on component unmount
      return () => {};
    }
  }, [specificPurchase]);

  const handleProduct = (rowData) => {
    console.log(rowData);
    const product = categories.find((pro) => pro.id === rowData.category);
    const subCategory = subCategories.find(
      (subCategory) => subCategory.id === rowData.sub_category_id
    );
    if (product && subCategory) {
      return `${product.name} - ${subCategory.name}`;
    }
    return ""; // Return an empty string if no matching product is found
  };

  const handleVarient = (rowData) => {
    const varient = allVarients.find(
      (vari) => vari.varient_id === rowData.varient
    );

    if (varient) {
      const parsedOptions = JSON.parse(varient.options);
      const optionLabel = parsedOptions.map((option) => {
        return `${option} - ${varient[option]?.value || "N/A"}`;
      });

      return optionLabel.map((op, i) => <div key={i}>{op}</div>);
    }

    return ""; // Return an empty string if no matching product is found
  };

  const [totalQty, setTotalQty] = useState(0);

  //   useEffect(() => {
  //     if (salesDetails) {
  //       let qty = 0;
  //       salesDetails.map((product) => {
  //         qty = qty + product.quantity;
  //       });
  //       setTotalQty(qty);
  //     }
  //   }, [salesDetails]);

  // useEffect(()=>{
  //   const customer = customers.find((customer) => customer.id === sales.customer_id);
  //   if (Object.keys(customer).length !== 0) {
  //     setCustomer(customer)
  //   } else {
  //     setCustomer({});
  //   }
  //   const staffs = staff.find((staff) => staff.id === sales.staff_id);
  //   if (Object.keys(staffs).length !== 0) {
  //     setSelectedStaff(staffs)
  //   } else {
  //     setSelectedStaff({})
  //   }
  // },[])

  //   useEffect(() => {
  //     const customer = customers.find(
  //       (customer) => customer.id === sales.customer_id
  //     );
  //     if (customer && Object.keys(customer).length !== 0) {
  //       setCustomer(customer);
  //     } else {
  //       setCustomer({});
  //     }

  //     const staffs = staff.find((staff) => staff.id === sales.staff_id);
  //     if (staffs && Object.keys(staffs).length !== 0) {
  //       setSelectedStaff(staffs);
  //     } else {
  //       setSelectedStaff({});
  //     }
  //   }, []);

  return (
    <div
      className="min-h-screen bg-white flex flex-col"
      style={{
        width: "794px", // A4 width at 96 DPI
        height: "1123px", // A4 height at 96 DPI
        padding: "1rem", // Adjustable padding
        margin: "0 auto", // Centers horizontally without excessive margins
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Optional shadow for effect
        backgroundColor: "white", // Ensures background is white
      }}
    >
      <div className="">
        {/* Header Section */}
        <div className="p-8 border-b">
          <div className="flex justify-between items-start">
            <div className="flex items-center gap-4">
              {logoUrl && (
                <img
                  src={logoUrl}
                  alt="Logo"
                  className="w-24 h-24 object-contain"
                />
              )}
              <div>
                <h1 className="text-2xl font-bold p-font-style">
                  {setupDetails?.name}
                </h1>
                <p className="text-sm text-gray-600">{setupDetails?.address}</p>
                <p className="text-sm text-gray-600">Gujrat</p>
                <p className="text-sm text-gray-600">
                  {setupDetails?.email} | {setupDetails?.phone}
                </p>
              </div>
            </div>
            <div className="text-right">
              <h2 className="text-xl font-bold p-font-style">
                {specificPurchase?.status === "refund" ? "REFUND" : "PURCHASE"}{" "}
                INVOICE
              </h2>
              <p className="text-gray-600">
                Invoice No:
                {specificPurchase?.id
                  ? String(specificPurchase.id).padStart(5, "0")
                  : ""}
              </p>
              <p className="text-sm mt-2">Date: {currentDate}</p>
              <p className="text-sm">Time: {currentTime}</p>
            </div>
          </div>
        </div>

        {/* Customer Information */}
        <div className="p-8 border-b">
          <div className="grid grid-cols-2 gap-8">
            <div>
              <h3 className="font-bold p-font-style mb-2">Bill To:</h3>
              <p className="text-sm">
                {specificPurchase?.customer_name || "Walk-in Customer"}
              </p>
              <p className="text-sm">
                {specificPurchase?.customer_phone || ""}
              </p>
            </div>
            <div className="text-right">
              <h3 className="font-bold p-font-style mb-2">Receipt By:</h3>
              <p className="text-sm">
                {/* {user?.first_name.concat(" ", user?.last_name) || ""} */}
                {setupDetails?.name}
              </p>
            </div>
          </div>
        </div>

        {/* Items Table */}
        <div className="p-8">
          <table className="w-full mb-8">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2">Product</th>
                <th className="text-right py-2">Qty</th>
                <th className="text-right py-2">Price</th>
                <th className="text-right py-2">Discount</th>
                <th className="text-right py-2">Total</th>
              </tr>
            </thead>
            <tbody>
              {specificPurchase?.products?.map((item, index) => (
                <tr key={index} className="border-b">
                  <td className="py-2">{handleProduct(item)}</td>
                  <td className="text-right py-2">{item.quantity}</td>
                  <td className="text-right py-2">
                    {item.unit_price.toLocaleString("en-IN")}
                  </td>
                  <td className="text-right py-2">
                    {item.discount.toLocaleString("en-IN")}
                  </td>
                  <td className="text-right py-2">
                    {item.total.toLocaleString("en-IN")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Summary */}
          <div className="w-1/2 ml-auto">
            <div className="flex justify-between py-2">
              <span>Subtotal:</span>
              <span>
                RS {specificPurchase?.total_sales?.toLocaleString("en-IN") || 0}
              </span>
            </div>
            <div className="flex justify-between py-2 border-b">
              <span>Discount:</span>
              <span>
                RS{" "}
                {specificPurchase?.total_discount?.toLocaleString("en-IN") || 0}
              </span>
            </div>
            <div className="flex justify-between py-4 font-bold p-font-style text-lg">
              <span>TOTAL:</span>
              <span>
                RS{" "}
                {specificPurchase?.total_amount?.toLocaleString("en-IN") || 0}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer with Thank You Section - Now properly positioned at bottom */}
      <div className="max-w-[210mm] mx-auto mt-auto border-t">
        <div className="p-8 text-center">
          <p className="text-xl font-bold p-font-style mb-4">THANK YOU!</p>
          <p className="mb-4">Follow us on Social Media</p>
          <div className="flex justify-center gap-4">
            <FaWhatsapp className="w-6 h-6" />
            <FaFacebook className="w-6 h-6" />
            <FaInstagram className="w-6 h-6" />
            <FaPinterest className="w-6 h-6" />
            <FaTwitter className="w-6 h-6" />
          </div>
        </div>
      </div>
      <div className="flex justify-end">
        <p className="text-sm text-gray-600">
          Software by Reys Solutions: 0311-6991588
        </p>
      </div>
    </div>
  );
}
